export const t = {
  shipping_costs: {
    en: 'Shipping costs',
    es: 'Costos de envío',
    au: 'Shipping costs',
    us: 'Shipping costs',
    it: 'Spese di spedizione'
  },
  duration: {
    en: 'Duration',
    es: 'Duración',
    au: 'Duration',
    us: 'Duration',
    it: 'Durata'
  },
  working_days: {
    en: 'working days',
    es: 'días laborables',
    au: 'working days',
    us: 'working days',
    it: 'giorni lavorativi'
  },
  within_the_eu: {
    en: 'within the EU',
    es: 'dentro de la UE',
    au: 'within the EU',
    us: 'within the EU',
    it: `nell'UE`
  },
  express_surcharge: {
    en: 'Express surcharge',
    es: 'Recargo exprés',
    au: 'Express surcharge',
    us: 'Express surcharge',
    it: 'Supplemento Express'
  },
  approximately: {
    en: 'approx',
    es: 'aproximadamente',
    au: 'approx',
    us: 'approx',
    it: 'circa'
  },
  continue_reading: {
    en: 'Continue reading',
    es: 'Sigue leyendo',
    au: 'Continue reading',
    us: 'Continue reading',
    it: 'Continua a leggere'
  },
  hello: {
    en: 'Hello',
    es: 'Hola',
    au: 'Hello',
    us: 'Hello',
    it: 'Ciao'
  }
}
